








































import { Component } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FeatureCard from '@/componentsV2/molecules/FeatureCard/FeatureCard.vue';
import eventBus from '@/utils/eventBus';
import { routes } from '@/router';
import { IBusinessType } from '@/models/business';
import InfoIcon from '@/components/icons/InfoV2.vue';
import segmentIo from '@/utils/segment.io';

import { orderFeatures } from './ordering';
import { needLaunchRewardsProgram } from '@/utils/start-guide';
import RewardsModel from '@/componentsV2/templates/RewardsModel/RewardsModel.vue';
import { widgetIsActive } from '@/router/validators/utils';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import { getBillingIsPending } from '@/utils/billing';

@Component({
  components: {
    Page,
    Typography,
    FeatureCard,
    InfoIcon
  }
})
export default class MyTools extends RewardsModel {
  features: any = [];

  get tPrefix() {
    return 'myTools';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get businessType() {
    return this.businessInfo.type;
  }

  get businessNeedsSetRewards() {
    return this.businessInfo.coinPurchaseRatio === '0.00';
  }

  get showedFeatures() {
    return this.features.filter((route: any) => !route.hide);
  }

  get hiddenFeatures() {
    return this.features.filter((route: any) => route.hide);
  }

  get disclaimer() {
    const names = this.hiddenFeatures
      .map((route: any) => ({
        ...route,
        order: orderFeatures.disclaimer[route.name]
      }))
      .sort(this.ordering)
      .map((route: any) => route.meta.feature.title || route.meta.navbar.name);
    const strHiddenFeatures = `${names.slice(0, -1).join('; ')} ${this.$t(
      'common.separators.and'
    )} ${names.slice(-1)}`;

    let disclaimer =
      this.businessInfo.country !== 'United States' ? 'notUSA' : 'default';

    return this.$t(`${this.tPrefix}.disclaimer.${disclaimer}`, {
      features: strHiddenFeatures
    });
  }

  get isBusinessOutsideUS() {
    return this.businessInfo.country !== 'United States';
  }

  getFeatureBlockText(route: any) {
    const type = route.blockedReward ? 'reward' : 'provider';
    return this.$t(`${this.tPrefix}.blockedText.${type}`);
  }

  getTextFromDisclaimer(disclaimerKey: string) {
    return this.$t(`common.routeDisclaimers.${disclaimerKey}`, {
      country: this.businessInfo.country
    });
  }

  back() {
    this.$router.back();
  }

  openConfirmRewards(type?: IBusinessType) {
    if (
      this.businessInfo.type === IBusinessType.BOTH &&
      type === IBusinessType.ONLINE
    ) {
      this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
        operationType: IBusinessType.ONLINE
      });
    }
    this.openRewardsProgramModal({
      operationType: this.businessInfo.operationType
    });
  }

  onClickFeature(route: any) {
    segmentIo.track('Clicked My Tools Feature', {
      Feature: route.meta.feature.title || route.meta.navbar.name
    });

    if (
      this.businessNeedsSetRewards &&
      route.name === 'program-status' &&
      !getBillingIsPending() &&
      this.businessInfo.subscriptionStatus !== EBillingStatusTypes.UNSUBSCRIBED
    ) {
      this.openRewardsProgramModal({
        operationType: this.businessInfo.operationType
      });
      return;
    }
    this.$router.push(route.path);
  }

  onClickLock(route: any) {
    segmentIo.track('Clicked My Tools Blocked CTA', {
      Feature: route.meta.feature.title || route.meta.navbar.name,
      Type: route.blockedReward ? 'Config Reward' : 'Connect Provider'
    });
    if (route.blockedReward) {
      if (
        !getBillingIsPending() &&
        this.businessInfo.subscriptionStatus !==
          EBillingStatusTypes.UNSUBSCRIBED
      ) {
        this.openConfirmRewards(IBusinessType.ONLINE);
      } else {
        this.$router.push(route.path);
      }
    } else {
      this.$router.push('/settings/apps');
    }
  }

  ordering(a: any, b: any) {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order > b.order) {
      return 1;
    }
    return 0;
  }

  orderingBlocked(a: any, b: any) {
    if (!a.blocked && b.blocked) {
      return -1;
    } else if (a.blocked && !b.blocked) {
      return 1;
    } else {
      return 0;
    }
  }

  loadFeatures() {
    this.features = routes.filter(route => !!route.meta.feature);

    if (this.businessNeedsSetRewards)
      this.features = this.features.map((item: any) => {
        if (
          (needLaunchRewardsProgram(true, item.path) &&
            item.name !== 'program-status') ||
          (this.isBusinessOutsideUS && item.name === 'marketingCenter')
        ) {
          return {
            ...item,
            blockedReward: true
          };
        }

        return item;
      });

    let someFeaturesBlocked = false;

    this.features = this.features.map((item: any) => {
      let hide = false;

      const needProviderConnected =
        item.meta.needProviderConnected && !widgetIsActive();
      const featureValidatorBlocked =
        item.meta.validator && !item.meta.validator().isValid;

      const blocked =
        item.blockedReward || featureValidatorBlocked || needProviderConnected;

      if (!someFeaturesBlocked && blocked) someFeaturesBlocked = true;

      if (
        this.businessType !== IBusinessType.ONLINE ||
        this.isBusinessOutsideUS
      ) {
        hide = !(
          item.meta.feature.type === this.businessType ||
          item.meta.feature.type === IBusinessType.BOTH ||
          this.businessType === IBusinessType.BOTH
        );
      }

      return {
        ...item,
        blocked,
        hide
      };
    });
    let ordering = someFeaturesBlocked ? 'blocked' : 'principal';

    this.features = this.features.map((item: any) => {
      let order = orderFeatures[this.businessType][ordering][item.name];

      if (this.businessNeedsSetRewards && item.name === 'program-status') {
        order = 0;
      }

      if (this.isBusinessOutsideUS && item.name === 'marketingCenter') {
        order = 11;
      }

      return { ...item, order };
    });

    this.features = this.features
      .sort(this.ordering)
      .sort(this.orderingBlocked);
  }

  created() {
    this.loadFeatures();
    eventBus.$on('rewardProgramSuccess', this.loadFeatures);
  }

  beforeDestroy() {
    eventBus.$off('rewardProgramSuccess', this.loadFeatures);
  }
}
